import { render, staticRenderFns } from "./oilOrderBackMoney.vue?vue&type=template&id=b934a644&scoped=true"
import script from "./oilOrderBackMoney.vue?vue&type=script&lang=js"
export * from "./oilOrderBackMoney.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b934a644",
  null
  
)

export default component.exports